import {WlModalFieldButtons} from "./modalFieldButtons.component";

export * from './modalFieldButtons.component';
export default WlModalFieldButtons;

customElements.define('wl-modal-field-buttons', WlModalFieldButtons);
